import {
  GET_ME_REQUEST,
  GET_ME_SUCCESS,
  GET_ME_FAILURE,
  AUTH_FAILURE,
  REFRESH_ME,
  IGNORE_TWITTER_TOKEN_REQUEST,
  IGNORE_TWITTER_TOKEN_SUCCESS,
  IGNORE_TWITTER_TOKEN_FAILURE,
  GENERATE_TWITTER_URL_REQUEST,
  GENERATE_TWITTER_URL_SUCCESS,
  GENERATE_TWITTER_URL_FAILURE,
  CLOSE_TWITTER_AUTHORIZATION_MODAL,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: {},
    error: false,
    isRequestedTwitterAuthorization: false,
    skippedRequests: 0,
    savedDataSourceAsDefault: undefined,
  };
};

const setCurrentUser = response => {
  const showTwitterCallbackUrl = response.prompt_for_twitter_token;
  const twitterTokenSettings =
    response.settings &&
    response.settings.find(set => set.key === 'TWITTER_TOKEN');
  const skippedRequests =
    (twitterTokenSettings && twitterTokenSettings.value.skipped_requests) || 0;
  const lastSkippedTimestamp =
    twitterTokenSettings && twitterTokenSettings.value.last_skipped_timestamp;

  const dateObject =
    lastSkippedTimestamp && new Date(lastSkippedTimestamp * 1000);
  const newDate =
    lastSkippedTimestamp &&
    new Date(dateObject.valueOf() + dateObject.getTimezoneOffset() * 60 * 1000);
  const diff = !newDate || new Date().getTime() - newDate.getTime() >= 86400000;

  const defaultDataSourceSettings =
    response.settings &&
    response.settings.find(set => set.key === 'DEFAULT_DATA_SOURCE');

  const savedDataSourceAsDefault =
    defaultDataSourceSettings && defaultDataSourceSettings.value.data_source;
  return {
    data: response,
    skippedRequests,
    isRequestedTwitterAuthorization: Boolean(showTwitterCallbackUrl && diff),
    savedDataSourceAsDefault,
  };
};
const initialState = getInitialState();

const me = (state = initialState, action) => {
  const types = {
    [GET_ME_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_ME_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      logout: false,
      ...setCurrentUser(action.response),
    }),
    [GET_ME_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
    [REFRESH_ME]: () => ({
      ...state,
      isLoading: false,
      error: false,
      ...setCurrentUser(action.response),
    }),
    [CLOSE_TWITTER_AUTHORIZATION_MODAL]: () => ({
      ...state,
      oAuthToken: null,
      twitterAuthWindow: null,
      isRequestedTwitterAuthorization: false,
    }),
    [IGNORE_TWITTER_TOKEN_REQUEST]: () => ({
      ...state,
      isIgnoringTwitterToken: true,
    }),
    [IGNORE_TWITTER_TOKEN_SUCCESS]: () => ({
      ...state,
      isIgnoringTwitterToken: false,
    }),
    [IGNORE_TWITTER_TOKEN_FAILURE]: () => ({
      ...state,
      isIgnoringTwitterToken: false,
    }),
    [GENERATE_TWITTER_URL_REQUEST]: () => ({
      ...state,
      isGeneratingTwitterUrl: true,
    }),
    [GENERATE_TWITTER_URL_SUCCESS]: () => ({
      ...state,
      oAuthToken: action.oAuthToken,
      twitterAuthWindow: action.twitterAuthWindow,
      isGeneratingTwitterUrl: false,
    }),
    [GENERATE_TWITTER_URL_FAILURE]: () => ({
      ...state,
      isGeneratingTwitterUrl: false,
    }),
    [AUTH_FAILURE]: () => ({
      logout: true,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default me;
